// // src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_BASE_URL || "https://portal.rapidmedik.com";

export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
});
